import React, { useState, useEffect, useRef } from "react";
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, Legend } from 'recharts';
import { Autocomplete, Avatar, Button, Box, Stack, TextField } from "@mui/material";
import clearFilterImage from "../../icons/clearFilter.svg"
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import LocationManagement from "../LocationManagement";
import StaffMovementReportModal from "../../components/modals/StaffMovementReportModal";
import searchIcon from "../../icons/searchIcon.svg"
import { Tabs, Tab } from "@mui/material";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import visitManagementIcon from "../../icons/sidebar/visitManagementIcon.svg"
import attendanceManagementIcon from "../../icons/sidebar/attendanceManagementIcon.svg"
import specimanManagementIcon from "../../icons/sidebar/specimanManagementIcon.svg"
import allowancesIcon from "../../icons/sidebar/allowances.svg"
import partyManagementIcon from "../../icons/sidebar/partyManagementIcon.svg"
import followUpIco from "../../icons/followUpClock.svg"

import { Link, useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [orderData, setOrderData] = useState([])
  const [data, setData] = useState({})
  const [allOrderData, setAllOrderData] = useState({});
  const [startDate, setStartDate] = useState('');
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user);
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allDashboardData, setAllDashboardData] = useState({});
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const [staffMovementReportOpen, setStaffMovementReportOpen] = useState(false);
  const [time, setTime] = useState(new Date());
  const [paperShow, setPaperShow] = useState(false);
  const timeRef = useRef(null);
  const [partyVisitCountData, setPartyVisitCountData] = useState({});
  const [partyCountAssignedOrNotData, setPartyCountAssignedOrNotData] = useState({});
  const [visitSummaryData, setVisitSummaryData] = useState({});
  const [discrepancyReportData, setDiscrepancyReportData] = useState({});
  const [visitCountNew, setVisitCountNew] = useState({});
  const [dayForDiscrepancy, setDayForDiscrepancy] = useState("3");
  const [newLoader, setNewLoader] = useState(false);
  const [followUpCountNew, setFollowUpCountNew] = useState({});
  const [filteredData, setFilteredData] = useState({});
  const [followUpLoading, setFollowUpLoading] = useState(false);

  const navigation = useNavigate()
  const loadingRef = useRef(0);

  const SkeletonBox = () => (
    <div
      style={{
        width: "100%",
        height: "50px",
        borderRadius: "10px",
        background: "linear-gradient(90deg, #e2e2e2ff 0%, #ece1e1ff 50%, #c2c2c2ff 100%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.4s infinite",
      }}
    ></div>
  );



  const startLoading = () => {
    loadingRef.current += 1;
    setLoading(true);
  };

  const stopLoading = () => {
    loadingRef.current -= 1;
    if (loadingRef.current === 0) {
      setLoading(false);
    }
  };

  // rs dashboard 

  useEffect(() => {
    const updateTime = () => {
      if (timeRef.current) {
        const now = new Date();
        const formattedDate = now.toLocaleDateString("en-GB"); // gives DD/MM/YYYY
        const formattedTime = now.toLocaleTimeString(); // gives HH:MM:SS
        const finalDate = formattedDate.replace(/\//g, "-"); // convert / to -
        timeRef.current.textContent = `📅 ${finalDate} ⏰ ${formattedTime}`;
      }
      requestAnimationFrame(updateTime); // keep updating
    };

    requestAnimationFrame(updateTime);

    return () => {
      cancelAnimationFrame(updateTime);
    };
  }, [selectedTab]);


  useEffect(() => {
    loadingRef.current = 0;
    setLoading(false);
    fetchSessions();
  }, [selectedTab])

  useEffect(() => {
    setNewLoader(true);
    getDiscrepancyReportData();
  }, [dayForDiscrepancy])

  useEffect(() => {
    fetchSessions();
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  const fetchSessions = async () => {
    startLoading();
    try {
      let filterdData1
      const response = await window.Platform.database.getAllSessions();
      if (response?.status) {
        filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
        setFilteredData(filterdData1[0])
        if (selectedTab == 0) {
          getPartyCountAssignedOrNot(filterdData1[0]);
          getDiscrepancyReportData(filterdData1[0]);
          getVisitSummaryData(filterdData1[0]);
          getCountVisitForWeb(filterdData1[0]);
          getCountFollowupVisits(filterdData1[0])
          getPartyVisitCounts(filterdData1[0]);
          fetchAllDashboardData(filterdData1[0]);
          fetchRoles()
        } else {
          fetchOrderData(filterdData1[0]);
        }
      }
      else {
        stopLoading();
        window.NotificationUtils.showError("Something Went Wrong In Session false");
        if (selectedTab == 0) {
          getPartyCountAssignedOrNot(filterdData1[0]);
          getDiscrepancyReportData(filterdData1[0]);
          getVisitSummaryData(filterdData1[0]);
          getCountVisitForWeb(filterdData1[0]);
          getCountFollowupVisits(filterdData1[0])
          getPartyVisitCounts(filterdData1[0]);
          fetchAllDashboardData(filterdData1[0]);
          fetchRoles()
        } else {
          fetchOrderData(filterdData1[0]);
        }
      }
    } catch (error) {
      if (selectedTab == 0) {
        getPartyCountAssignedOrNot();
        getDiscrepancyReportData();
        getVisitSummaryData();
        getCountVisitForWeb();
        getCountFollowupVisits()
        getPartyVisitCounts();
        fetchAllDashboardData();
        fetchRoles()
      } else {
        fetchOrderData();
      }
      console.error("Error fetching sessions:", error);
      window.NotificationUtils.showError("Failed to load sessions catch");
      stopLoading();
    }
    finally {
      stopLoading();
    }
  };


  async function getAllUsers() {
    try {
      startLoading();
      let results = await window.Platform.database.fetchEmployees()
      if (results?.status) {
        return window.NotificationUtils.showError(results?.message || "Something went wrong getAllUsers");
      }
      else {
        setAllUsers(results?.data)
        setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
        setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
        setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      }
    } catch (error) {
      console.log(error)
      stopLoading();
    }
    finally {
      stopLoading();
    }
  }

  async function getPartyVisitCounts(data12) {
    try {
      startLoading();
      const payload = {
        // rsm: rsm,
        // asm: asm,

        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        ownerName: rm,
        fromDate: startDate,
        toDate: endDate,
        // fromDate: startDate != '' ? startDate : data12?.startDate,
        // toDate: endDate != '' ? endDate : data12?.endDate,
      }
      let results = await window.Platform.database.getPartyVisitCounts(payload)
      if (results?.status) {
        setPartyVisitCountData(results?.data)
      }
      else {
        setPartyVisitCountData({})
        stopLoading();
      }
    } catch (error) {
      console.log(error);
      stopLoading();
    }
    finally {
      stopLoading();
    }

  }

  async function getPartyCountAssignedOrNot(data12) {
    try {
      startLoading();
      const payload = {

        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        // rsm: rsm,
        // asm: asm,
        ownerName: rm,
        // fromDate: startDate != '' ? startDate : data12?.startDate,
        // toDate: endDate != '' ? endDate : data12?.endDate,
        fromDate: startDate,
        toDate: endDate,
      }
      let results = await window.Platform.database.getPartyCountAssignedOrNot(payload)
      if (results?.status) {
        setPartyCountAssignedOrNotData(results?.data);
      }
      else {
        setPartyCountAssignedOrNotData({});

      }
    } catch (error) {
      console.log(error);
      stopLoading();
    }
    finally {
      stopLoading();
    }
  }

  async function getVisitSummaryData(data12) {
    try {
      startLoading();
      const payload = {
        // rsm: rsm,
        // asm: asm,

        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        ownerName: rm,
        // fromDate: startDate != '' ? startDate : data12?.startDate  || "",
        // toDate: endDate != '' ? endDate : data12?.endDate || "",
        fromDate: startDate,
        toDate: endDate,
      }
      let results = await window.Platform.database.getVisitSummaryData(payload)
      if (results?.status) {
        setVisitSummaryData(results?.data);
      }
      else {
        setVisitSummaryData({});
        stopLoading();

      }
    } catch (error) {
      console.log(error);
      stopLoading();
    }
    finally {
      stopLoading();
    }
  }

  async function getDiscrepancyReportData(data12) {
    try {
      startLoading();
      const payload = {
        // rsm: rsm,
        // asm: asm,

        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        ownerName: rm,
        data: dayForDiscrepancy,
        // fromDate: startDate != '' != '' ? startDate : data12?.startDate|| "",
        // toDate: endDate != '' != '' ? endDate : data12?.endDate || "",
        fromDate: startDate,
        toDate: endDate,
      }
      let results = await window.Platform.database.getDiscrepancyReportData(payload)
      if (results?.status) {
        setDiscrepancyReportData(results?.data);
        setNewLoader(false);
      }
      else {
        setDiscrepancyReportData({});
        setNewLoader(false);
      }
    } catch (error) {
      console.log(error);
    }
    finally {
      stopLoading();
    }
  }

  async function getUsers(role, id) {
    try {
      if (id != "") {
        let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
        if (role == 'rsm') {
          setAsms(results?.data)
          setRms(results?.data1)
        }
        if (role == 'asm') {
          setRms(results?.data);
        }
      } else {
        if (role == 'rsm') {
          setRm("")
          setAsm("")
          setRms(allUsers?.filter((ele) => ele.role == 'se'))
          setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
        }
        if (role == 'asm') {
          setRm("")
          setRms(allUsers?.filter((ele) => ele.role == 'se'))
        }
      }
    } catch (error) {
      console.log(error);
      stopLoading();
    }
    finally {
      stopLoading();
    }
  }

  const goToHoActionableItems = async () => {
    navigate('/LocationManagement', { state: { request_type_id: 29 } });
  }

  async function handleClearFilters() {
    try {
      startLoading();
      setFollowUpLoading(true);
      setStartDate('');
      setEndDate('');
      setAsm('');
      setRsm('');
      setRm('');

      setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
      setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
      setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));

      if (selectedTab == 0) {
        const payload = {
          rsm: userData?.role == 'rsm' ? userData?.id : rsm || "",
          asm: userData?.role == 'asm' ? userData?.id : asm || "",
          ownerName: "",
          fromDate: "",
          toDate: "",
        }
        let results = await window.Platform.database.getPartyCountAssignedOrNot(payload)
        if (results?.status) {
          setPartyCountAssignedOrNotData(results?.data);
        }
        // ---------------------------------------------------------------------
        const payload1 = {
          rsm: userData?.role == 'rsm' ? userData?.id : rsm || "",
          asm: userData?.role == 'asm' ? userData?.id : asm || "",
          ownerName: "",
          data: 3,
          fromDate: "",
          toDate: "",
        }
        let results1 = await window.Platform.database.getDiscrepancyReportData(payload1)
        if (results1?.status) {
          setDiscrepancyReportData(results1?.data);
          setNewLoader(false);
        }
        // ---------------------------------------------------------------------
        const payload2 = {
          rsm: userData?.role == 'rsm' ? userData?.id : rsm || "",
          asm: userData?.role == 'asm' ? userData?.id : asm || "",
          ownerName: "",
          fromDate: "",
          toDate: "",
        }
        let results2 = await window.Platform.database.getVisitSummaryData(payload2)
        if (results2?.status) {
          setVisitSummaryData(results2?.data);
        }
        // ---------------------------------------------------------------------
        let payload3 = {
          rsm: userData?.role == 'rsm' ? userData?.id : rsm || "",
          asm: userData?.role == 'asm' ? userData?.id : asm || "",
          ownerName: "",
          fromDate: "",
          toDate: "",
        }
        let newResult = await window.Platform.database.getCountVisitForWeb(payload3);
        if (newResult?.success) {
          setVisitCountNew(newResult?.data)
        }
        // ---------------------------------------------------------------------
        let payload4 = {
          fromDate: "",
          toDate: "",
          rsm: userData?.role == 'rsm' ? userData?.id : rsm,
          asm: userData?.role == 'asm' ? userData?.id : asm,
          ownerName: ""
        }
        let newResult1 = await window.Platform.database.getAllDataForDashBoard(payload4);
        if (newResult1?.success) {
          setAllDashboardData(newResult1?.data)
        }
        // ---------------------------------------------------------------------
        const payload6 = {
          rsm: userData?.role == 'rsm' ? userData?.id : rsm || "",
          asm: userData?.role == 'asm' ? userData?.id : asm || "",
          ownerName: rm,
          fromDate: startDate,
          toDate: endDate,
        }
        let results3 = await window.Platform.database.getPartyVisitCounts(payload6)
        if (results3?.status) {
          setPartyVisitCountData(results3?.data)
        }
      // stopLoading();
      setLoading(false);
          // ---------------------------------------------------------------------
        let payload5 = {
          rsm: userData?.role == 'rsm' ? userData?.id : rsm || "",
          asm: userData?.role == 'asm' ? userData?.id : asm || "",
          ownerName: "",
          fromDate: "",
          toDate: "",
        }
        let newResult2 = await window.Platform.database.getCountFollowupVisits(payload5);
        if (newResult2?.status) {
          window.NotificationUtils.showError(newResult2?.message || "Something went wrong getCountFollowupVisits");
      setFollowUpLoading(false);
        }
        else {
          setFollowUpCountNew(newResult2?.data)
        }
        // ---------------------------------------------------------------------
        // fetchRoles()
      } else {
        let data1 = {
          startDate: "",
          endDate: "",
          rsm: userData?.role == 'rsm' ? userData?.id : rsm || "",
          asm: userData?.role == 'asm' ? userData?.id : asm || "",
          ownerName: ""
        };

        let results = await window.Platform.database.fetchOrderDash(data1);

        if (results?.status) {
          stopLoading();
          setLoading(false);
          window.Platform.database.showToast("error", results?.message + 4 || "Something went wrong fetchOrderDash");
          setOrderData([]);
          setData({});
          setAllOrderData({
            sales: { total: 0, amount: 0 },
            specimen: { total: 0, amount: 0 }
          });
        } else {
          const orders = results?.data?.order || [];
          setOrderData(orders);
          setData(results?.data);

          // ------------------ FIXED allOrderData --------------------
          const salesTotal = orders.filter(o => o.orderType?.toLowerCase() === "sales")
            .reduce((sum, o) => sum + o.status_count, 0);
          const salesAmount = orders.filter(o => o.orderType?.toLowerCase() === "sales")
            .reduce((sum, o) => sum + o.total_amount, 0);

          const specimenTotal = orders.filter(o => o.orderType?.toLowerCase() === "specimen")
            .reduce((sum, o) => sum + o.status_count, 0);
          const specimenAmount = orders.filter(o => o.orderType?.toLowerCase() === "specimen")
            .reduce((sum, o) => sum + o.total_amount, 0);

          setAllOrderData({
            sales: { total: salesTotal, amount: salesAmount },
            specimen: { total: specimenTotal, amount: specimenAmount }
          });
          // -----------------------------------------------------------
          stopLoading();
          setLoading(false);
        }
      }
    }
    catch (e) {
      console.log(e)
      stopLoading();
      setFollowUpLoading(false);
    }
    finally {
      stopLoading();
      setFollowUpLoading(false);
    }
  }
  const downloadStaffMovement = async () => {
    setStaffMovementReportOpen(true)
  }
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // async function fetchOrderData(data12) {
  //   if (startDate > endDate) {
  //     return window.alert("Choose Correct Date Range");
  //   }
  //   try {
  //     let data1 = {
  //       startDate: startDate,
  //       endDate: endDate,
  //     //   startDate: startDate != '' ? startDate : data12?.startDate,
  //     // endDate: endDate != '' ? endDate : data12?.endDate,
  //       // rsm: rsm,
  //       // asm: asm,

  //       rsm: userData?.role == 'rsm' ? userData?.id : rsm,
  //       asm: userData?.role == 'asm' ? userData?.id : asm,
  //       ownerName: rm
  //     }
  //     let results = await window.Platform.database.fetchOrderDash(data1);
  //     if (results?.status) {
  //       window.Platform.database.showToast("error", results?.message || "Something went wrong");
  //       setOrderData([]);
  //       setData({});
  //       setAllOrderData({ total: 0, amount: 0 });
  //     }
  //     else {
  //       setOrderData(results?.data?.order)
  //       setData(results?.data)
  //       setAllOrderData({ total: results?.data?.order?.reduce((p, q) => { return p + q?.status_count }, 0), amount: results?.data?.order?.reduce((p, q) => { return p + q?.total_amount }, 0) })
  //     }
  //   }
  //   catch (e) {
  //     console.log(e)
  // stopLoading();
  //   }
  // finally{
  //     stopLoading();
  // }
  // }
  async function fetchOrderData(data12) {
    if (startDate > endDate) {
      return window.alert("Choose Correct Date Range");
    }
    try {
      // startLoading();
      let data1 = {
        // startDate: startDate,
        // endDate: endDate,
        startDate: startDate != '' ? startDate : data12?.startDate,
        endDate: endDate != '' ? endDate : data12?.endDate,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        ownerName: rm
      };

      let results = await window.Platform.database.fetchOrderDash(data1);

      if (results?.status) {
        setLoading(false);
        stopLoading();
        window.Platform.database.showToast("error", results?.message + 5 || "Something went wrong fetchOrderDash");
        setOrderData([]);
        setData({});
        setAllOrderData({
          sales: { total: 0, amount: 0 },
          specimen: { total: 0, amount: 0 }
        });
      } else {
        const orders = results?.data?.order || [];
        setOrderData(orders);
        setData(results?.data);

        // ------------------ FIXED allOrderData --------------------
        const salesTotal = orders.filter(o => o.orderType?.toLowerCase() === "sales")
          .reduce((sum, o) => sum + o.status_count, 0);
        const salesAmount = orders.filter(o => o.orderType?.toLowerCase() === "sales")
          .reduce((sum, o) => sum + o.total_amount, 0);

        const specimenTotal = orders.filter(o => o.orderType?.toLowerCase() === "specimen")
          .reduce((sum, o) => sum + o.status_count, 0);
        const specimenAmount = orders.filter(o => o.orderType?.toLowerCase() === "specimen")
          .reduce((sum, o) => sum + o.total_amount, 0);

        setAllOrderData({
          sales: { total: salesTotal, amount: salesAmount },
          specimen: { total: specimenTotal, amount: specimenAmount }
        });
        // stopLoading();
        setLoading(false);
        stopLoading();
      }
    } catch (e) {
      console.log(e);
      stopLoading();
      setLoading(false);
    }
    finally {
      stopLoading();
      setLoading(false);
    }
  }

  async function fetchAllDashboardData(data12) {
    if (startDate > endDate) {
      return window.alert("Choose Correct Date Range");
    }
    try {
      startLoading(true);
      let payload = {
        // fromDate: startDate ? startDate : data12?.startDate,
        // toDate: endDate ? endDate : data12?.endDate,
        fromDate: startDate,
        toDate: endDate,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        ownerName: rm
      }
      let newResult = await window.Platform.database.getAllDataForDashBoard(payload);
      if (newResult?.success) {
        setAllDashboardData(newResult?.data)
      }
      else {
        window.NotificationUtils.showError(newResult?.message || "Something went wrong getAllDataForDashBoard");
        stopLoading();
      }
    }
    catch (e) {
      console.log(e)
      stopLoading();
    }
    finally {
      stopLoading();
    }
  }

  async function getCountVisitForWeb(data12) {
    if (startDate > endDate) {
      return window.alert("Choose Correct Date Range");
    }
    try {
      startLoading();
      let payload = {
        // rsm: rsm,
        // asm: asm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        ownerName: rm,
        fromDate: startDate != '' ? startDate : data12?.startDate,
        toDate: endDate != '' ? endDate : data12?.endDate
        // fromDate: startDate,
        // toDate: endDate,

      }
      let newResult = await window.Platform.database.getCountVisitForWeb(payload);
      if (newResult?.success) {
        setVisitCountNew(newResult?.data)
      }
      else {
        window.NotificationUtils.showError(newResult?.message || "Something went wrong getCountVisitForWeb");
        stopLoading();
      }
      // setData(results?.data)
      // setAllOrderData({ total: results?.data?.order?.reduce((p, q) => { return p + q?.status_count }, 0), amount: results?.data?.order?.reduce((p, q) => { return p + q?.total_amount }, 0) })
    }
    catch (e) {
      console.log(e)
      stopLoading();
    }
    finally {
      stopLoading();
    }
  }


  // async function getCountFollowupVisits(data12) {
  //   if (startDate > endDate) {
  //     return window.alert("Choose Correct Date Range");
  //   }
  //   try {
  //     startLoading();
  //     let payload = {
  //       // rsm: rsm,
  //       // asm: asm,
  //       rsm: userData?.role == 'rsm' ? userData?.id : rsm,
  //       asm: userData?.role == 'asm' ? userData?.id : asm,
  //       ownerName: rm,
  //       // fromDate: startDate != '' ? startDate : data12?.startDate,
  //       // toDate: endDate != '' ? endDate : data12?.endDate
  //       fromDate: startDate,
  //       toDate: endDate,

  //     }
  //     let newResult = await window.Platform.database.getCountFollowupVisits(payload);
  //     if (newResult?.status) {
  //       window.NotificationUtils.showError(newResult?.message || "Something went wrong getCountFollowupVisits");
  //     }
  //     else {
  //       setFollowUpCountNew(newResult?.data)
  //     }
  //     // setData(results?.data)
  //     // setAllOrderData({ total: results?.data?.order?.reduce((p, q) => { return p + q?.status_count }, 0), amount: results?.data?.order?.reduce((p, q) => { return p + q?.total_amount }, 0) })
  //   }
  //   catch (e) {
  //     console.log(e)
  //     stopLoading();
  //   }
  //   finally {
  //     stopLoading();
  //   }
  // }
  async function getCountFollowupVisits(data12) {
    if (startDate > endDate) {
      return window.alert("Choose Correct Date Range");
    }

    try {
      setFollowUpLoading(true);

      let payload = {
        rsm: userData?.role == "rsm" ? userData?.id : rsm,
        asm: userData?.role == "asm" ? userData?.id : asm,
        ownerName: rm,
        fromDate: startDate,
        toDate: endDate,
      };

      let newResult = await window.Platform.database.getCountFollowupVisits(payload);

      if (newResult?.status) {
        window.NotificationUtils.showError(
          newResult?.message || "Something went wrong getCountFollowupVisits"
        );
      } else {
        setFollowUpCountNew(newResult?.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setFollowUpLoading(false);
    }
  }

  const [roleId, setRoleId] = useState([])

  const fetchRoles = async () => {
    try {
      startLoading();
      let results = await window.Platform.database.fetchRoles();
      setRoleId(results?.data)
    }
    catch (err) {
      console.log(err);
      stopLoading();
    }
    finally {
      stopLoading();
    }
  }

  // const EnhancedOrdersGraph = ({ allOrderData, orderData }) => {
  // const data = [
  // { name: 'All Booked Orders', count: allOrderData?.total || 0 },
  // { name: 'Approved Orders', count: orderData?.filter((ele) => ele.approvalStatus === 1)[0]?.status_count || 0 },
  // { name: 'Pending Orders', count: orderData?.filter((ele) => ele.approvalStatus === 0)[0]?.status_count || 0 },
  // { name: 'Rejected Orders', count: orderData?.filter((ele) => ele.approvalStatus === 2)[0]?.status_count || 0 },
  // { name: 'Shipped Orders', count: orderData?.filter((ele) => ele.approvalStatus === 3)[0]?.status_count || 0 },
  // { name: 'Delivered Orders', count: orderData?.filter((ele) => ele.approvalStatus === 4)[0]?.status_count || 0 },
  // ];

  // return (
  // <div style={{ width: '100%', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
  // {/* <h4>Orders</h4> */}
  // <ResponsiveContainer width="100%" height={300}>
  // <BarChart
  // data={data}
  // margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
  // barSize={50}
  // >
  // <CartesianGrid strokeDasharray="3 3" />
  // <XAxis dataKey="name" tick={{ fontSize: 12 }} angle={-20} textAnchor="end" />
  // <YAxis />
  // <Tooltip cursor={{ fill: 'rgba(200, 200, 200, 0.2)' }} />
  // <Bar dataKey="count" fill="url(#gradient)" radius={[8, 8, 0, 0]}>
  // <LabelList dataKey="count" position="top" style={{ fill: 'black', fontWeight: 'bold' }} />
  // </Bar>
  // <defs>
  // <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
  // <stop offset="0%" stopColor="#4caf50" />
  // <stop offset="100%" stopColor="#81c784" />
  // </linearGradient>
  // </defs>
  // </BarChart>
  // </ResponsiveContainer>
  // </div>
  // );
  // };
  // const EnhancedOrdersGraph = ({ allOrderData, orderData }) => {
  //   const data = [
  //     {
  //       name: 'All Booked Orders',
  //       count: allOrderData?.total || 0,
  //       amount: allOrderData?.amount || 0
  //     },
  //     {
  //       name: 'Approved Orders',
  //       count: orderData?.filter((ele) => ele.approvalStatus === 1)[0]?.status_count || 0,
  //       amount: orderData?.filter((ele) => ele.approvalStatus === 1)[0]?.total_amount || 0
  //     },
  //     {
  //       name: 'Pending Orders',
  //       count: orderData?.filter((ele) => ele.approvalStatus === 0)[0]?.status_count || 0,
  //       amount: orderData?.filter((ele) => ele.approvalStatus === 0)[0]?.total_amount || 0
  //     },
  //     {
  //       name: 'Rejected Orders',
  //       count: orderData?.filter((ele) => ele.approvalStatus === 2)[0]?.status_count || 0,
  //       amount: orderData?.filter((ele) => ele.approvalStatus === 2)[0]?.total_amount || 0
  //     },
  //     {
  //       name: 'Shipped Orders',
  //       count: orderData?.filter((ele) => ele.approvalStatus === 3)[0]?.status_count || 0,
  //       amount: orderData?.filter((ele) => ele.approvalStatus === 3)[0]?.total_amount || 0
  //     },
  //     {
  //       name: 'Delivered Orders',
  //       count: orderData?.filter((ele) => ele.approvalStatus === 4)[0]?.status_count || 0,
  //       amount: orderData?.filter((ele) => ele.approvalStatus === 4)[0]?.total_amount || 0
  //     },
  //   ];
  //   return (
  //     <div style={{ width: '100%', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '3px', height: 350, marginTop: "10px", boxShadow: '0 4px 8px rgba(0, 0, 0, 0.52)' }}>
  //       <h4 style={{ color: "black", fontWeight: "500" }}>Order Data</h4>
  //       <ResponsiveContainer width="100%" height={300}>
  //         <BarChart
  //           data={data}
  //           margin={{ top: 20, right: 30, left: 50, bottom: 50 }}
  //           barSize={40}
  //         >
  //           <CartesianGrid strokeDasharray="3 3" />
  //           <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} angle={-20} textAnchor="end" stroke="#111" />
  //           <YAxis tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} stroke="#111" />
  //           <Tooltip
  //             cursor={{ fill: 'rgba(200, 200, 200, 0.2)' }}
  //             formatter={(value, name, props) => {
  //               if (name === "count") return [`${value}`, "Number"];
  //               if (name === "amount") return [`₹ ${value}`, "Amount"];
  //               return value;
  //             }}
  //           />
  //           <Bar dataKey="count" fill="url(#gradient)" radius={[8, 8, 0, 0]}>
  //             {/* <LabelList dataKey="count" position="top" style={{ fill: 'black', fontWeight: 'bold' }} /> */}
  //           </Bar>
  //           <Bar dataKey="amount" fill="#64b5f6" radius={[8, 8, 0, 0]}>
  //             {/* <LabelList dataKey="amount" position="top" style={{ fill: 'black', fontWeight: 'bold' }} /> */}
  //           </Bar>
  //           <defs>
  //             <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
  //               <stop offset="0%" stopColor="#4caf50" />
  //               <stop offset="100%" stopColor="#81c784" />
  //             </linearGradient>
  //           </defs>
  //         </BarChart>
  //       </ResponsiveContainer>
  //     </div>
  //   );
  // };
  const OrdersGraph = ({ orderData, allOrderData }) => {
    // const getValues = (status) => {
    //   const sales = orderData.find(
    //     ele => ele.approvalStatus === status && ele.orderType.toLowerCase() === "sales"
    //   );
    //   const specimen = orderData.find(
    //     ele => ele.approvalStatus === status && ele.orderType.toLowerCase() === "specimen"
    //   );

    //   return {
    //     salesCount: sales?.status_count || 0,
    //     specimenCount: specimen?.status_count || 0,
    //     salesAmount: sales?.total_amount || 0,
    //     specimenAmount: specimen?.total_amount || 0,
    //   };
    // };
    const getValues = (status) => {
      const sales = orderData.find(
        ele => ele.approvalStatus === status && ele.orderType.toLowerCase() === "sales"
      );

      let specimen;

      if (status === 6) {
        specimen = orderData.find(
          ele => ele.approvalStatus === 6 && ele.orderType.toLowerCase() === "specimen"
        );
      }
      else if (status === 4) {
        const allSpecimen = orderData.filter(
          ele => ele.orderType.toLowerCase() === "specimen" && ele.approvalStatus !== 6
        );

        specimen = {
          status_count: allSpecimen.reduce((p, q) => p + q.status_count, 0),
          total_amount: allSpecimen.reduce((p, q) => p + q.total_amount, 0),
        };
      }
      else {
        specimen = { status_count: 0, total_amount: 0 };
      }

      return {
        salesCount: sales?.status_count || 0,
        specimenCount: specimen?.status_count || 0,
        salesAmount: sales?.total_amount || 0,
        specimenAmount: specimen?.total_amount || 0,
      };
    };


    const data = [
      {
        name: "All Booked Orders",
        sales: allOrderData?.sales?.total || 0,
        specimen: allOrderData?.specimen?.total || 0
      },
      {
        name: "Approved Orders",
        sales: getValues(1).salesCount,
        specimen: getValues(1).specimenCount
      },
      {
        name: "Pending Orders",
        sales: getValues(0).salesCount,
        specimen: getValues(0).specimenCount
      },
      {
        name: "Rejected Orders",
        sales: getValues(2).salesCount,
        specimen: getValues(2).specimenCount
      },
      {
        name: "Shipped Orders",
        sales: getValues(3).salesCount,
        specimen: getValues(3).specimenCount
      },
      {
        name: "Delivered Orders",
        sales: getValues(4).salesCount,
        specimen: getValues(4).specimenCount
      },
      {
        name: "Saved For Later",
        sales: getValues(6).salesCount,
        specimen: getValues(6).specimenCount
      },
    ];

    return (
      <div style={{
        width: '100%',
        padding: '10px',
        backgroundColor: '#f8f9fa',
        borderRadius: '6px',
        height: 350,
        marginTop: "10px",
        boxShadow: '0 4px 8px rgba(0,0,0,0.25)'
      }}>

        {/* <h4 style={{ color: "black", fontWeight: "500" }}>
        Sales And Specimen Orders  
      </h4> */}
        <h4 style={{ color: "black", fontWeight: "500", display: "flex", alignItems: "center", gap: "20px" }}>
          Sales And Specimen Orders

          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span style={{ width: "14px", height: "14px", backgroundColor: "#2196f3", borderRadius: "3px" }}></span>
            <span style={{ fontSize: "14px", color: "#000" }}>Sales</span>
          </span>

          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span style={{ width: "14px", height: "14px", backgroundColor: "#9c27b0", borderRadius: "3px" }}></span>
            <span style={{ fontSize: "14px", color: "#000" }}>Specimen</span>
          </span>
        </h4>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} margin={{ top: 20, right: 30, left: 50, bottom: 50 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} angle={-20} textAnchor="end" />
            <YAxis tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} />
            <Tooltip />

            {/* Sales Bar */}
            <Bar dataKey="sales" fill="#2196f3" name="Sales" radius={[6, 6, 0, 0]} />

            {/* Specimen Bar */}
            <Bar dataKey="specimen" fill="#9c27b0" name="Specimen" radius={[6, 6, 0, 0]} />

          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };


  const EnhancedPartyDataGraph = ({ data }) => {
    const chartData = [
      { name: 'Party Onboarded', count: data?.sch?.active_count + data?.d?.active_count || 0 }, //{data?.sch?.active_count+data?.d?.active_count}
      { name: 'Schools', count: data?.sch?.active_count || 0 }, //{data?.sch?.active_count}
      { name: 'Distributors', count: data?.d?.active_count || 0 }, //{data?.d?.active_count
      { name: 'Stockist', count: data?.st?.active_count || 0 }, //{data?.st?.active_count}
    ];

    return (
      <div style={{ marginTop: 15, width: '100%', padding: '20px', backgroundColor: '#f8f9fa', height: 380, borderRadius: '3px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.52)' }}>
        <h4 style={{ color: "black", fontWeight: "500" }}>Party Data</h4>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 30, bottom: 50 }}
            barSize={35}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} angle={-20} textAnchor="end" stroke="#111" />
            <YAxis tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} stroke="#111" />
            <Tooltip cursor={{ fill: 'rgba(200, 200, 200, 0.2)' }} formatter={(value, name) => [`${value}`, "Count"]} />
            <Bar dataKey="count" fill="url(#partyGradient)" radius={[8, 8, 0, 0]}>
              {/* <LabelList dataKey="count" position="top" style={{ fill: 'black', fontWeight: 'bold' }} /> */}
            </Bar>
            <defs>
              <linearGradient id="partyGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#ff9800" />
                <stop offset="100%" stopColor="#ffcc80" />
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };

  const EnhancedTeamDataGraph = ({ data, roleId }) => {
    const chartData = roleId?.map((ele) => ({
      name: ele?.name,
      count: data?.users?.filter((e) => e.role.toLowerCase() === ele.roleName.toLowerCase())[0]?.status_count || 0,
    }));

    return (
      <div style={{ marginTop: 15, width: '100%', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '3px', height: 380, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.52)' }}>
        <h4 style={{ color: "black", fontWeight: "500" }}>Team Data</h4>
        <ResponsiveContainer width="100%" height={340}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
            barSize={30}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} angle={-20} textAnchor="end" height={70} stroke="#111" interval={0} />
            <YAxis tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} stroke="#111" />
            <Tooltip cursor={{ fill: 'rgba(200, 200, 200, 0.2)' }} formatter={(value, name) => [`${value}`, "Count"]} />
            <Bar dataKey="count" fill="url(#teamGradient)" radius={[8, 8, 0, 0]}>
              {/* <LabelList dataKey="count" position="top" style={{ fill: 'black', fontWeight: 'bold' }} /> */}
            </Bar>
            <defs>
              <linearGradient id="teamGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#2196f3" />
                <stop offset="100%" stopColor="#64b5f6" />
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };

  const EnhancedProductsGraph = ({ data }) => {
    // Prepare the chart data
    const chartData = [
      {
        name: 'All Series',
        count: Array.isArray(data?.product) ? data?.product?.reduce((p, q) => p + q.status_count, 0) : 0,
        incentive: 0,
      },
      ...(Array.isArray(data?.series) ? data?.series.map((ele) => ({
        name: ele.seriesName.toUpperCase(),
        count: data?.product?.filter((e) => e.seriesCategory === ele.seriesTableId)[0]?.status_count || 0,
        incentive: data?.incentive?.filter((e) => e.seriesId === ele.seriesTableId)[0]?.status_count || 0,
      })) : []),
    ];

    return (
      <div style={{ width: '100%', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '3px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.52)' }}>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
            barSize={40}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} stroke="#111" angle={-20} textAnchor="end" />
            <YAxis tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} stroke="#111" />
            <Tooltip cursor={{ fill: 'rgba(200, 200, 200, 0.2)' }} formatter={(value, name) => [`${value}`, "Count"]} />

            <Bar dataKey="count" fill="url(#productGradient)" radius={[8, 8, 0, 0]}>
              <LabelList dataKey="count" position="top" style={{ fill: 'black', fontWeight: 'bold' }} />
            </Bar>

            {/* <Bar dataKey="incentive" fill="url(#incentiveGradient)" radius={[8, 8, 0, 0]}>
              <LabelList dataKey="incentive" position="top" style={{ fill: 'black', fontWeight: 'bold' }} />
            </Bar> */}

            <defs>
              <linearGradient id="productGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#f57c00" />
                <stop offset="100%" stopColor="#ffb74d" />
              </linearGradient>
              <linearGradient id="incentiveGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#388e3c" />
                <stop offset="100%" stopColor="#66bb6a" />
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>

      </div>
    );
  };

  const EnhancedSeriesGraph = ({ data }) => {
    // Prepare the chart data
    const chartData = [
      {
        name: 'All Series',
        Amount: Array.isArray(data?.items) ? data?.items?.reduce((p, q) => p + q.total_amount, 0) : 0,
      },
      ...(Array.isArray(data?.series) ? data?.series.map((ele) => ({
        name: ele?.seriesName?.toUpperCase(),
        Amount: data?.items?.filter((e) => e?.series === ele?.seriesTableId)[0]?.total_amount || 0,
      })) : []),
    ];

    return (
      <div style={{ width: '100%', padding: '10px', backgroundColor: '#f8f9fa', marginTop: "10px", borderRadius: '3px', height: 350, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.52)' }}>
        <h4 style={{ color: "black", fontWeight: "500" }}>Series Wise Amount</h4>
        <ResponsiveContainer width="100%" height={340}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 10, left: 50, bottom: 50 }}
            barSize={40}
          >
            <CartesianGrid strokeDasharray="3 3" />
            {/* <XAxis dataKey="name" tick={{ fontSize: 12 }} angle={-20} textAnchor="end" /> */}
            <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#111", fontWeight: 500 }} stroke="#111" angle={-30} textAnchor="end" height={70} interval={0} />
            <YAxis tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} stroke="#111" />
            <Tooltip cursor={{ fill: 'rgba(200, 200, 200, 0.2)' }} formatter={(value, name) => [`${value}`, "Count"]} />

            <Bar dataKey="Amount" fill="url(#productGradient)" radius={[8, 8, 0, 0]}>
              {/* <LabelList dataKey="Amount" position="top" style={{ fill: 'black', fontWeight: 'bold' }} /> */}
            </Bar>

            <defs>
              <linearGradient id="productGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#f57c00" />
                <stop offset="100%" stopColor="#ffb74d" />
              </linearGradient>
              <linearGradient id="incentiveGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#388e3c" />
                <stop offset="100%" stopColor="#66bb6a" />
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>

      </div>
    );
  };


  const EnhancedVisitDataGraph = ({ data }) => {
    const chartData = [
      { name: 'Planned', count: data?.route?.total_routes || 0 }, //{data?.sch?.active_count+data?.d?.active_count}
      { name: 'Completed', count: data?.route?.complete || 0 }, //{data?.sch?.active_count}
      { name: 'Running', count: data?.route?.running || 0 },
      { name: 'Pending', count: data?.route?.pending || 0 },
    ];

    return (
      <div style={{ marginTop: 15, width: '100%', padding: '20px', backgroundColor: '#f8f9fa', height: 380, borderRadius: '3px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.52)' }}>
        <h4 style={{ color: "black", fontWeight: "500" }}>Visit Data</h4>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 30, bottom: 50 }}
            barSize={35}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} angle={-20} textAnchor="end" stroke="#111" />
            <YAxis tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} stroke="#111" />
            <Tooltip cursor={{ fill: 'rgba(200, 200, 200, 0.2)' }} formatter={(value, name) => [`${value}`, "Count"]} />
            <Bar dataKey="count" fill="url(#partyGradient)" radius={[8, 8, 0, 0]}>
              <LabelList dataKey="count" position="top" style={{ fill: 'black', fontWeight: 'bold', fontSize: 14 }} />
            </Bar>
            <defs>
              <linearGradient id="partyGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#ff9800" />
                <stop offset="100%" stopColor="#ffcc80" />
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };

  const EnhanceFieldSalesTeamGraph = ({ data }) => {
    const chartData = [
      { name: 'Total', count: data?.Attendence?.total || 0 },
      { name: 'Present', count: data?.Attendence?.present || 0 },
      { name: 'On Leave', count: data?.Attendence?.leave || 0 },
      { name: 'No Login / No Update', count: data?.Attendence?.no_login_no_update || 0 },
    ];

    return (
      <div style={{ marginTop: 15, width: '100%', padding: '20px', backgroundColor: '#f8f9fa', height: 380, borderRadius: '3px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.52)' }}>
        <h4 style={{ color: "black", fontWeight: "500" }}>Field Sales Team</h4>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 30, bottom: 50 }}
            barSize={35}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} angle={-20} textAnchor="end" stroke="#111" />
            <YAxis tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} stroke="#111" />
            <Tooltip cursor={{ fill: 'rgba(200, 200, 200, 0.2)' }} formatter={(value, name) => [`${value}`, "Count"]} />
            <Bar dataKey="count" fill="url(#partyGradient)" radius={[8, 8, 0, 0]}>
              <LabelList dataKey="count" position="top" style={{ fill: 'black', fontWeight: 'bold' }} />
            </Bar>
            <defs>
              <linearGradient id="partyGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#ff9800" />
                <stop offset="100%" stopColor="#ffcc80" />
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };

  const EnhancedClaimsGraph = ({ data }) => {
    const chartData = [
      { name: 'Total', count: data?.Expenses?.total_expenses || 0 },
      { name: 'Approved', count: data?.Expenses?.approve || 0 },
      { name: 'Pending', count: data?.Expenses?.pending || 0 },
      { name: 'Rejected', count: data?.Expenses?.rejected || 0 },
      { name: 'Sattled', count: data?.Expenses?.sattled || 0 },
    ];

    return (
      <div style={{ marginTop: 15, width: '100%', padding: '20px', backgroundColor: '#f8f9fa', height: 380, borderRadius: '3px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.52)' }}>
        <h4 style={{ color: "black", fontWeight: "500" }}>Claimed</h4>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 30, bottom: 50 }}
            barSize={35}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} angle={-20} textAnchor="end" stroke="#111" />
            <YAxis tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} stroke="#111" />
            <Tooltip cursor={{ fill: 'rgba(200, 200, 200, 0.2)' }} formatter={(value, name) => [`${value}`, "Count"]} />
            <Bar dataKey="count" fill="url(#partyGradient)" radius={[8, 8, 0, 0]}>
              <LabelList dataKey="count" position="top" style={{ fill: 'black', fontWeight: 'bold' }} />
            </Bar>
            <defs>
              <linearGradient id="partyGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#ff9800" />
                <stop offset="100%" stopColor="#ffcc80" />
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };

  const EnhancedSpecimenRequestGraph = ({ data }) => {
    const chartData = [
      { name: 'Total', count: data?.Specimen?.total_specimen || 0 },
      { name: 'Approved', count: data?.Specimen?.approve || 0 },
      { name: 'Pending', count: data?.Specimen?.pending || 0 },
      { name: 'Rejected', count: data?.Specimen?.rejected || 0 },
    ];

    return (
      <div style={{ marginTop: 15, width: '100%', padding: '20px', backgroundColor: '#f8f9fa', height: 380, borderRadius: '3px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.52)' }}>
        <h4 style={{ color: "black", fontWeight: "500" }}>Specimen Requests</h4>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 30, bottom: 50 }}
            barSize={35}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} angle={-20} textAnchor="end" stroke="#111" />
            <YAxis tick={{ fontSize: 12, fill: "#111", fontWeight: 500 }} stroke="#111" />
            <Tooltip cursor={{ fill: 'rgba(200, 200, 200, 0.2)' }} formatter={(value, name) => [`${value}`, "Count"]} />
            <Bar dataKey="count" fill="url(#partyGradient)" radius={[8, 8, 0, 0]}>
              <LabelList dataKey="count" position="top" style={{ fill: 'black', fontWeight: 'bold' }} />
            </Bar>
            <defs>
              <linearGradient id="partyGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#ff9800" />
                <stop offset="100%" stopColor="#ffcc80" />
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };
  return (
    <>
      {loading && <OpaqueLoading />}
      <div className="d-flex justify-content-end">
        <Button variant="contained" color="primary" className="mt-1" style={{ marginRight: "65px" }} onClick={() => { paperShow ? setPaperShow(false) : setPaperShow(true) }}>Search  <span className="ml-1"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0z" fill="none" /><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" /></svg></span></Button>
      </div>
      {paperShow &&
        <Box sx={{ mt: 1, width: "100%" }}>
          <Paper
            elevation={3}
            sx={{
              p: 2,
              mb: 1,
              width: "100%",
              // maxWidth: "1100px",
              mx: "auto",
              backgroundColor: "#f9fbff",
              borderRadius: "12px",
            }}
          >
            <div className="container-fluid" style={{ width: "100%" }}>
              <div className="row g-3">
                {userData?.role.includes("admin") && (
                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ fontWeight: 500 }}>Select HO</InputLabel>
                      <Select
                        value={rsm}
                        label="Select HO"
                        onChange={(e) => {
                          setRsm(e.target.value);
                          getUsers("rsm", e.target.value);
                          setAsm("");
                          setRm("");
                        }}
                      >
                        <MenuItem value="">All</MenuItem>
                        {rsms.map((role) => (
                          <MenuItem key={role.id} value={role.id}>
                            {role.name} - {role.username}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                )}

                {userData?.role !== "asm" && (
                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ fontWeight: 500 }}>Select ARM</InputLabel>
                      <Select
                        value={asm}
                        label="Select ARM"
                        onChange={(e) => {
                          setAsm(e.target.value);
                          getUsers("asm", e.target.value);
                          setRm("");
                        }}
                      >
                        <MenuItem value="">All</MenuItem>
                        {asms.map((role) => (
                          <MenuItem key={role.id} value={role.id}>
                            {role.name} - {role.username}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                )}

                <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ fontWeight: 500 }}>Select RM</InputLabel>
                    <Select
                      value={rm}
                      label="Select RM"
                      onChange={(e) => setRm(e.target.value)}
                    >
                      <MenuItem value="">All</MenuItem>
                      {rms.map((role) => (
                        <MenuItem key={role.id} value={role.id}>
                          {role.name} - {role.username}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                {/* <div className="col-md-3 d-flex align-items-center">
                  <Button
                    // size="small"
                    sx={{
                      fontSize: '14px',
                      borderRadius: '10px',
                      fullWidth: true,
                      // backgroundColor: '#E1AD01', // deeper mustard color
                      backgroundColor: '#c99b00',
                      color: 'white', // ensure text is readable
                      '&:hover': {
                        // backgroundColor: '#c99b00', // hover effect
                        backgroundColor: '#c99b00',
                        color: 'white'
                      }
                    }}
                    // variant="outlined"
                    color="info"
                    fullWidth
                    onClick={goToHoActionableItems}
                  >
                    HO Actionable Items
                  </Button>
                </div> */}
              </div>

              {/* ====== DATE FILTER ROW ====== */}
              <div className="row g-3 mt-3 align-items-end">
                <div className="col-md-3">
                  <TextField
                    label="From Date"
                    type="date"
                    fullWidth
                    size="small"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>

                <div className="col-md-3">
                  <TextField
                    label="To Date"
                    type="date"
                    fullWidth
                    size="small"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>

                <div className="col-md-3">
                  <Button
                    variant="contained"
                    fullWidth
                    // onClick={() => { selectedTab == 0 ? newAllFunCall() : fetchOrderData() }}
                    onClick={() => { fetchSessions() }}
                  // disabled={!startDate && !endDate}
                  >
                    Find
                  </Button>
                </div>

                <div className="col-md-3">
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={
                      <img
                        src={clearFilterImage}
                        alt="clear"
                        height="20"
                        width="20"
                      />
                    }
                    fullWidth
                    sx={{ fontSize: "12px", borderRadius: "8px" }}
                    onClick={() => { handleClearFilters() }}
                  // disabled={!startDate && !endDate}
                  >
                    Clear Filters
                  </Button>
                </div>
              </div>
              <div className="row mt-3">
                {/* <div className="col-md-4">
                  <Button variant="contained" color="success" size="small" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => downloadStaffMovement()}>
                    Staff @ 10 AM Report
                  </Button>
                </div> */}
              </div>
            </div>
          </Paper>
        </Box>}
      {/* {paperShow && selectedTab == 1 && <Box sx={{ mt: 1, width: "100%" }}>
        <Paper
          elevation={3}
          sx={{
            p: 2,
            mb: 1,
            width: "100%",
            maxWidth: "1100px",
            mx: "auto",
            backgroundColor: "#f9fbff",
            borderRadius: "12px",
          }}
        >
          <div className="container-fluid" style={{ width: "100%" }}>
            <div className="row g-3 mt-3 align-items-end">
              <div className="col-md-3">
                <TextField
                  label="From Date"
                  type="date"
                  fullWidth
                  size="small"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </div>

              <div className="col-md-3">
                <TextField
                  label="To Date"
                  type="date"
                  fullWidth
                  size="small"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </div>

              <div className="col-md-1">
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => { selectedTab == 0 ? fetchAllDashboardData() : fetchOrderData() }}
                // disabled={!startDate && !endDate}
                >
                  Find
                </Button>
              </div>

              <div className="col-md-2">
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={
                    <img
                      src={clearFilterImage}
                      alt="clear"
                      height="18"
                      width="18"
                    />
                  }
                  fullWidth
                  sx={{ fontSize: "11px", borderRadius: "8px" }}
                  onClick={handleClearFilters}
                // disabled={!startDate && !endDate}
                >
                  Clear Filters
                </Button>
              </div>
            </div>
          </div>
        </Paper>
      </Box>} */}

      <Box sx={{ mt: 1, mb: 1, width: "100%" }}>
        <Paper
          elevation={3}
          sx={{
            p: 2,
            mb: 0,
            width: "100%",
            // maxWidth: "1100px",
            mx: "auto",
            backgroundColor: "#f9fbff",
            borderRadius: "12px",
          }}
        >
          <div className="row">
            <div className="col-md-3 d-flex align-items-center">
              <Button
                // size="small"
                sx={{
                  fontSize: '14px',
                  borderRadius: '10px',
                  fullWidth: true,
                  // backgroundColor: '#E1AD01', // deeper mustard color
                  backgroundColor: '#c99b00',
                  color: 'white', // ensure text is readable
                  '&:hover': {
                    // backgroundColor: '#c99b00', // hover effect
                    backgroundColor: '#c99b00',
                    color: 'white'
                  }
                }}
                // variant="outlined"
                color="info"
                fullWidth
                onClick={goToHoActionableItems}
              >
                HO Actionable Items
              </Button>
            </div>
            <div className="col-md-4">
              <Button variant="contained" color="success" size="small" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => downloadStaffMovement()}>
                Staff @ 10 AM Report
              </Button>
            </div>
            <div
              className="col-md-4 d-flex justify-content-end align-items-center"
              style={{
                fontFamily: "monospace",
                minWidth: "250px",
                whiteSpace: "pre",
                fontSize: "15px",
              }}
            >
              <span ref={timeRef}></span>
            </div>
          </div>
        </Paper>
      </Box>
      <Tabs value={selectedTab} onChange={handleTabChange} variant="fullWidth" textColor="primary"
        indicatorColor="none" centered>
        <Tab label="Field Operations" sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 0 ? "#fff" : "#e6e3e3de " }} />
        <Tab label="Sales Dashboard " sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 0 ? "#e6e3e3de " : "#fff" }} />
      </Tabs>
      {selectedTab === 0 && (
        <>
          <div className="container-fluid">
            <div className="row mt-1">
              <div className="col-md-6">
                <div className="row">
                  <table className="table-borderless mt-1">
                    <tr>
                      <td style={{ width: "80px", textAlign: "center", verticalAlign: "middle" }}>
                        <div className="d-flex flex-column align-items-center">
                          <img src={visitManagementIcon} alt="VISIT" style={{ height: "25px", marginBottom: "4px" }} />
                          <span style={{ fontSize: "12px", fontWeight: "bold" }}>VISITS</span>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #d4880dff, #e56a06ff)",
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontSize: "12px",
                                fontWeight: "600",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              PLANNED
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.route?.total_routes || 0}
                            </p>

                            <RemoveRedEyeIcon
                              onClick={() => navigate("/visitmanagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #0033beff, #0000ffff)",
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              COMPLETED
                            </h4>
                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.route?.complete || 0}
                            </p>

                            <RemoveRedEyeIcon
                              onClick={() => navigate("/visitmanagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #46d200ff, #00ae0eff)",
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              RUNNING
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.route?.running || 0}
                            </p>

                            <RemoveRedEyeIcon
                              onClick={() => navigate("/visitmanagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #be0088ff, #86064cff)",
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)"
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              PENDING
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.route?.pending || 0}
                            </p>

                            <RemoveRedEyeIcon
                              onClick={() => navigate("/visitmanagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "80px", textAlign: "center", verticalAlign: "middle" }}>
                        <div className="d-flex flex-column align-items-center">
                          <img src={followUpIco} alt="VISIT" style={{ height: "25px", marginBottom: "4px" }} />
                          <span style={{ fontSize: "12px", fontWeight: "bold" }}>Follow Up</span>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #023284ff, #0831d4ff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            {
                              followUpLoading ? <SkeletonBox /> : <>
                                <h4
                                  style={{
                                    margin: 0,
                                    color: "#fff",
                                    fontWeight: "600",
                                    fontSize: "12px",
                                    letterSpacing: "1px",
                                    textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                                  }}
                                >
                                  PLANNED
                                </h4>

                                <p
                                  style={{
                                    marginTop: "1px",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    color: "#fff",
                                    textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                                  }}
                                >
                                  {followUpCountNew?.followupVisitCount || 0}
                                </p>
                              </>
                            }
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/reportcentral")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #2ca600ff, #66c607ff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            {
                              followUpLoading ? <SkeletonBox /> : <><h4
                                style={{
                                  margin: 0,
                                  color: "#fff",
                                  fontWeight: "600",
                                  fontSize: "12px",
                                  letterSpacing: "1px",
                                  textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                                }}
                              >
                                ATTENDED
                              </h4>

                                <p
                                  style={{
                                    marginTop: "1px",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    color: "#fff",
                                    textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                                  }}
                                >
                                  {followUpCountNew?.completeFollowupVisitCount || 0}
                                </p></>}
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/reportcentral")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #bca300ff, #978d04ff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            {
                              followUpLoading ? <SkeletonBox /> : <>  <h4
                                style={{
                                  margin: 0,
                                  color: "#fff",
                                  fontWeight: "600",
                                  fontSize: "12px",
                                  letterSpacing: "1px",
                                  textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                                }}
                              >
                                PENDING
                              </h4>

                                <p
                                  style={{
                                    marginTop: "1px",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    color: "#fff",
                                    textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                                  }}
                                >
                                  {followUpCountNew?.pendingFollowupCount || 0}
                                </p></>}
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/reportcentral")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #aa0707ff, #a70505ff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            {
                              followUpLoading ? <SkeletonBox /> : <> <h4
                                style={{
                                  margin: 0,
                                  color: "#fff",
                                  fontWeight: "600",
                                  fontSize: "12px",
                                  letterSpacing: "1px",
                                  textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                                }}
                              >
                                CHANGED
                              </h4>

                                <p
                                  style={{
                                    marginTop: "1px",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    color: "#fff",
                                    textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                                  }}
                                >
                                  {followUpCountNew?.followupVisitCountChangedDate || 0}
                                </p></>}
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/reportcentral")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "80px", textAlign: "center", verticalAlign: "middle" }}>
                        <div className="d-flex flex-column align-items-center">
                          <img src={attendanceManagementIcon} alt="VISIT" style={{ height: "25px", marginBottom: "4px" }} />
                          <span style={{ fontSize: "10px", fontWeight: "bold" }}>ATTENDANCE</span>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #08e0c6ff, #019472ff)",
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)"
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              TOTAL
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Attendence?.total || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/attendancemanagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #0ecf00ff, #659602ff)",
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)"
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              PRESENT
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Attendence?.present || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/attendancemanagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="" >
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #d506ffff, #940188ff)",
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontSize: "12px",
                                fontWeight: "600",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              ON LEAVE
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Attendence?.leave || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/attendancemanagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg,  #111a6cff, #111a6cff)",
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h6
                              style={{
                                marginTop: "4px",
                                color: "#fff",
                                fontSize: "9px",
                                fontWeight: "600",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              NO LOGIN / NO UPDATE
                            </h6>

                            <p
                              style={{
                                marginTop: "0px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Attendence?.no_login_no_update || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/attendancemanagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "80px", textAlign: "center", verticalAlign: "middle" }}>
                        <div className="d-flex flex-column align-items-center">
                          <img src={specimanManagementIcon} alt="VISIT" style={{ height: "25px", marginBottom: "4px" }} />
                          <span style={{ fontSize: "12px", fontWeight: "bold" }}>SPECIMEN</span>
                        </div>
                      </td>
                      <td>
                        <div className="" >
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #ffa200ff, #bcaa05ff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              TOTAL
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Specimen?.total_specimen || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/specimenAllotment")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #cd0048ff, #a10259ff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              APPROVED
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Specimen?.approve || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/specimenAllotment")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #0033beff, #0000ffff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              PENDING
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Specimen?.pending || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/specimenAllotment")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #970000ff, #d20000ff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              REJECTED
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Specimen?.rejected || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/specimenAllotment")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "80px", textAlign: "center", verticalAlign: "middle" }}>
                        <div className="d-flex flex-column align-items-center">
                          <img src={allowancesIcon} alt="VISIT" style={{ height: "25px", marginBottom: "4px" }} />
                          <span style={{ fontSize: "12px", fontWeight: "bold" }}>CLAIMS</span>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #00a08eff, #01b47eff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              TOTAL
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Expenses?.total_expenses || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/expenseManagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #b77a00ff, #b77a00ff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              APPROVED
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Expenses?.approve || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/expenseManagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #a00056ff, #a00056ff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              PENDING
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Expenses?.pending || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/expenseManagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="">
                          <div
                            style={{
                              color: "#fff",
                              background: "linear-gradient(135deg, #ff0000ff, #ff0000ff)", // darker blue gradient
                              borderRadius: "12px",
                              paddingTop: "10px",
                              textAlign: "center",
                              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                              minHeight: "60px",
                              position: "relative",
                              transition: "all 0.3s ease",
                              transform: "translateY(0px)",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "12px",
                                letterSpacing: "1px",
                                textShadow: "0px 1px 2px rgba(0,0,0,0.3)",
                              }}
                            >
                              REJECTED
                            </h4>

                            <p
                              style={{
                                marginTop: "1px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#fff",
                                textShadow: "0px 1px 3px rgba(0,0,0,0.3)",
                              }}
                            >
                              {allDashboardData?.Expenses?.rejected || 0}
                            </p>
                            <RemoveRedEyeIcon
                              onClick={() => navigate("/expenseManagement")}
                              style={{
                                fontSize: "20px",
                                color: "#fff",
                                cursor: "pointer",
                                position: "absolute",
                                bottom: "5px",
                                right: "8px",
                                opacity: 0.9,
                                transition: "all 0.3s ease",
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                {/* <hr style={{ width: "100%", height: "1px", backgroundColor: "#000", border: "none" }} /> */}
                <div className="row mt-0 p-3">
                  <h5
                    style={{
                      display: "inline-block",
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "#000"
                    }}
                    className="ml-2"
                  >
                    Visits (School)
                  </h5>
                  <table className="table-striped">
                    <thead>
                      <tr style={{ backgroundColor: "#ffffffff" }}>
                        <td style={{ textAlign: "center", fontWeight: "600", fontSize: "18px", padding: 4 }}>Parameters</td>
                        <td style={{ textAlign: "center", fontWeight: "600", fontSize: "18px", padding: 4 }}>Count / Average</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ textAlign: "center", fontSize: "16px", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>Last 7 days Visits</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>{visitSummaryData?.school?.last7DaysVisits || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#eef1f5cc" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}> Last 7 days Daily Avg Visits</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>{(visitSummaryData?.school?.avg7DaysVisits)?.toFixed(2) || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>Last 30 Days Visits</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}> {visitSummaryData?.school?.lastMonthVisits || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#eef1f5cc" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>Last 30 Days Daily Avg Visits</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>   {visitSummaryData?.school?.avgMonthVisits || 0} </td>
                      </tr>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>No Repeat Visit in Last 30 days</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}> {visitSummaryData?.school?.noVisitsLast30Days || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#eef1f5cc" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>Visited in last 3 months</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>{partyVisitCountData?.school?.visitedCount || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>No Repeat Visit in last 3 months</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>{partyVisitCountData?.school?.notVisitedCount || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#eef1f5cc" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>No Visit Yet (Party)</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}> {visitSummaryData?.school?.noVisitParties || 0} </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row justify-content-center text-center p-3">
                  <h5
                    style={{
                      color: "#000",
                      fontSize: "18px",
                      fontWeight: "700",
                      marginBottom: "4px",
                    }}
                  >
                    Parties :
                    <span className="mx-2" style={{ color: "#000000ff" }}>Schools</span> |
                    <span className="mx-2" style={{ color: "#000000ff" }}>Distributors</span>
                  </h5>
                  <table className="table-striped" style={{ border: "1px solid #000", borderRadius: "8px" }}>
                    <tbody>
                      <tr style={{ backgroundColor: "#ffffffff" }}>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 9, textAlign: "center" }}>
                          Schools
                        </td>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 9, textAlign: "center" }}>
                          Assigned
                        </td>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 9, textAlign: "center" }}>
                          Not Yet Assigned
                        </td>
                      </tr>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 9, }}>
                          {partyCountAssignedOrNotData?.totalSchools || 0}
                        </td>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 9, }}>
                          {partyCountAssignedOrNotData?.assignedSchools || 0}
                        </td>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 9, }}>
                          {partyCountAssignedOrNotData?.notAssignedSchools || 0}
                        </td>
                      </tr>
                      <tr style={{ backgroundColor: "#ffffffff" }}>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 8, textAlign: "center" }}>
                          Distributors
                        </td>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 8, textAlign: "center" }}>
                          Assigned
                        </td>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 8, textAlign: "center" }}>
                          Not Yet Assigned
                        </td>
                      </tr>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 8, }}>
                          {partyCountAssignedOrNotData?.totalDistributors || 0}
                        </td>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 8, }}>
                          {partyCountAssignedOrNotData?.assignedDistributors || 0}
                        </td>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 8, }}>
                          {partyCountAssignedOrNotData?.notAssignedDistributors || 0}
                        </td>
                      </tr>
                      <tr style={{ backgroundColor: "#ffffffff" }}>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 8, textAlign: "center" }}>
                          Schools
                        </td>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 8, textAlign: "center" }}>
                          Total Visits
                        </td>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 8, textAlign: "center" }}>
                          Unique visits
                        </td>
                      </tr>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 8, }}>
                          {/* {visitCountNew?.schoolCount || 0} */}
                          {partyCountAssignedOrNotData?.totalSchools || 0}
                        </td>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 8, }}>
                          {visitCountNew?.totalSchoolVisit || 0}
                        </td>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 8, }}>
                          {visitCountNew?.totalSchoolDistinctVisit || 0}
                        </td>
                      </tr>

                      <tr style={{ backgroundColor: "#ffffffff" }}>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 8, textAlign: "center" }}>
                          Distributors
                        </td>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 8, textAlign: "center" }}>
                          Total Visits
                        </td>
                        <td style={{ fontSize: "16px", fontWeight: "600", padding: 8, textAlign: "center" }}>
                          Unique visits
                        </td>
                      </tr>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 8, }}>
                          {partyCountAssignedOrNotData?.totalDistributors || 0}
                        </td>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 8, }}>
                          {visitCountNew?.totalDistributorVisit || 0}
                        </td>
                        <td style={{ fontWeight: "500", textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 8, }}>
                          {visitCountNew?.totalDistributorDistinctVisit || 0}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* <hr style={{ width: "100%", height: "1px", backgroundColor: "#000", border: "none" }} /> */}

                <div className="row mt-0 p-3">
                  <h5
                    style={{
                      display: "inline-block",
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "#000"
                    }}
                    className="ml-2"
                  >
                    Visits (Distributor / Dealer)
                  </h5>
                  <table className="table-striped">
                    <thead>
                      <tr style={{ backgroundColor: "#ffffffff" }}>
                        <td style={{ textAlign: "center", fontWeight: "600", fontSize: "18px", padding: 4 }}>Parameters</td>
                        <td style={{ textAlign: "center", fontWeight: "600", fontSize: "18px", padding: 4 }}>Count / Average</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ textAlign: "center", fontSize: "16px", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>Last 7 days Visits</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>{visitSummaryData?.distributor?.last7DaysVisits || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#eef1f5cc" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}> Last 7 days Daily Avg Visits</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>{(visitSummaryData?.distributor?.avg7DaysVisits)?.toFixed(2) || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>Last 30 Days Visits</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}> {visitSummaryData?.distributor?.lastMonthVisits || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#eef1f5cc" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>Last 30 Days Daily Avg Visits</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>   {visitSummaryData?.distributor?.avgMonthVisits || 0} </td>
                      </tr>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>No Repeat Visit in Last 30 days</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}> {visitSummaryData?.distributor?.noVisitsLast30Days || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#eef1f5cc" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>Visited in last 3 months</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>{partyVisitCountData?.distributor?.visitedCount || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>No Repeat Visit in last 3 months</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>{partyVisitCountData?.distributor?.notVisitedCount || 0}</td>
                      </tr>
                      <tr style={{ backgroundColor: "#eef1f5cc" }}>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}>No Visit Yet (Party)</td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 4 }}> {visitSummaryData?.distributor?.noVisitParties || 0} </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="row mt-0 p-1">
              <div className="col-md-6">
                <h5
                  style={{
                    display: "inline-block",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#000",
                    textAlign: "start",
                    display: "flex",
                    alignItems: "left",
                    justifyContent: "flex-start",
                  }}
                  className="ml-2"
                >
                  Visits (Over All)
                </h5>
                <table className="table-striped">
                  <thead>
                    <tr style={{ backgroundColor: "#ffffffff" }}>
                      <td style={{ textAlign: "center", fontWeight: "600", fontSize: "18px", padding: 5 }}>Parameters</td>
                      <td style={{ textAlign: "center", fontWeight: "600", fontSize: "18px", padding: 5 }}>Count / Average</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                      <td style={{ textAlign: "center", fontSize: "16px", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Last 7 days Visits</td>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{visitSummaryData?.school?.last7DaysVisits + visitSummaryData?.distributor?.last7DaysVisits || 0}</td>
                    </tr>
                    <tr style={{ backgroundColor: "#eef1f5cc" }}>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}> Last 7 days Daily Avg Visits</td>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{(visitSummaryData?.school?.avg7DaysVisits + visitSummaryData?.distributor?.avg7DaysVisits)?.toFixed(2) || 0}</td>
                    </tr>
                    <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Last 30 Days Visits</td>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}> {visitSummaryData?.school?.lastMonthVisits + visitSummaryData?.distributor?.lastMonthVisits || 0}</td>
                    </tr>
                    <tr style={{ backgroundColor: "#eef1f5cc" }}>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Last 30 Days Daily Avg Visits</td>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>   {(visitSummaryData?.school?.avgMonthVisits + visitSummaryData?.distributor?.avgMonthVisits)?.toFixed(2) || 0} </td>
                    </tr>
                    <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>No Repeat Visit in Last 30 days</td>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}> {visitSummaryData?.school?.noVisitsLast30Days + visitSummaryData?.distributor?.noVisitsLast30Days || 0} </td>
                    </tr>
                    <tr style={{ backgroundColor: "#eef1f5cc" }}>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Visited in last 3 months</td>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{partyVisitCountData?.school?.visitedCount + partyVisitCountData?.distributor?.visitedCount || 0}</td>
                    </tr>
                    <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>No Repeat Visit in last 3 months</td>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{partyVisitCountData?.school?.notVisitedCount + partyVisitCountData?.distributor?.notVisitedCount || 0}</td>
                    </tr>
                    <tr style={{ backgroundColor: "#eef1f5cc" }}>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>No Visit Yet (Party)</td>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}> {visitSummaryData?.school?.noVisitParties + visitSummaryData?.distributor?.noVisitParties || 0}</td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <div className="col-md-6">
                <div className="row mb-1">
                  <div className=" col-md-8" style={{ fontSize: "18px", fontWeight: "700", color: "#000" }}>
                    <div className="row">
                      <div className="col-md-6">
                        Discrepancy Report

                      </div>
                      <div className="col-md-6">
                        <select
                          className="form-control form-select ml-3"
                          style={{ fontWeight: "500", fontSize: "16px" }}
                          defaultValue="3"
                          onChange={(e) => setDayForDiscrepancy(e.target.value)}
                        >
                          <option value="3">Last 3 Days</option>
                          <option value="7">Last 7 Days</option>
                          <option value="30">Last 30 Days</option>
                          <option value="90">Last 3 Months</option>
                          <option value="lifetime">Lifetime</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-4">
                    <Link to={"/reportcentral"}>
                      <Button
                      className="form-control"
                        variant="contained"
                        style={{
                          backgroundColor: "#4dbde9ff",
                          // width: "100%",
                          color: "#000",
                          fontWeight: 500,
                          fontSize: "16px",
                          padding: 1.3,
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#32325d"; // blue
                          e.target.style.color = "#fff"; // white text
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "#4dbde9ff"; // original color
                          e.target.style.color = "#000"; // black text
                        }}
                      >
                        View
                      </Button>
                    </Link>
                  </div> */}
                </div>
                <div className="row mt-2">
                  <table className="table-striped">
                    <thead>
                      <tr style={{ backgroundColor: "#ffffffff" }}>
                        <td style={{ textAlign: "center", fontWeight: "600", fontSize: "18px", padding: 5 }}>Parameters</td>
                        <td style={{ textAlign: "center", fontWeight: "600", fontSize: "18px", padding: 5 }}>Count / Average</td>
                      </tr>
                    </thead>
                    {newLoader ? (
                      <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                        <td colSpan={2} style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Loading ...</td>
                      </tr>
                    ) : (
                      <tbody>
                        <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>No Route Plan Created</td>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.noRoutePlanCreated || 0}</td>
                        </tr>
                        <tr style={{ backgroundColor: "#eef1f5cc" }}>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Forced Visit Closed By Admin</td>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.forcedVisitClosed || 0}</td>
                        </tr>
                        <tr style={{ backgroundColor: "#eef1f5cc" }}>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Auto Close Visits By Server</td>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.autoClosedVisit || 0}</td>
                        </tr>
                        <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Location Mismatch</td>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.totalCountlocationMismatchCount || 0}</td>
                          {/* <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.locationMismatchCount || 0}</td> */}
                        </tr>
                        <tr style={{ backgroundColor: "#eef1f5cc" }}>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Overall Average Visits / Day</td>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.overallAvgVisitsPerDay || 0}</td>
                        </tr>
                        <tr style={{ backgroundColor: "#eef1f5cc" }}>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Average Daily Visits / User</td>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.avgDailyVisitsPerUser || 0}</td>
                        </tr>
                        <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>Users below Average Visit Mark</td>
                          <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.belowAvgVisitUsers || 0}</td>
                        </tr>
                        <td
                          style={{
                            textAlign: "center",
                            color: "#000000ff",
                            fontSize: "16px",
                            fontWeight: "500",
                            padding: 5
                          }}
                        >
                          {(() => {
                            switch (dayForDiscrepancy) {
                              case "3":
                                return "No activity in Last 3 days";
                              case "7":
                                return "No activity in Last 7 days";
                              case "30":
                                return "No activity in Last 30 days";
                              case "90":
                                return "No activity in Last 3 months";
                              case "lifetime":
                                return "No activity in lifetime";
                              default:
                                return "No activity";
                            }
                          })()}
                        </td>
                        <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.noActivityUsers || 0}</td>
                        {/* <tr style={{ backgroundColor: "#eef1f5cc" }}>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>No activity in last 3 days</td>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.noActivity3Days || 0}</td>
                    </tr>
                    <tr style={{ backgroundColor: "#d8e3f3ff" }}>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>No activity in last 7 days</td>
                      <td style={{ textAlign: "center", color: "#000000ff", fontSize: "16px", fontWeight: "500", padding: 5 }}>{discrepancyReportData?.noActivity7Days || 0}</td>
                    </tr> */}
                      </tbody>
                    )}                </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {selectedTab === 1 && (
        <Grid container spacing={3} sx={{ padding: 3 }}>
          {/*
<Grid container justifyContent="center" alignItems="center">
<Grid item xs={12} md={6}>
<EnhancedVisitDataGraph data={allDashboardData} />
</Grid>


<Grid item xs={12} md={6}>
<EnhanceFieldSalesTeamGraph data={allDashboardData} />
</Grid>
</Grid> */}

          {/* <Grid container justifyContent="center" alignItems="center">

<Grid item xs={12} md={6}>
<EnhancedClaimsGraph data={allDashboardData} />
</Grid>

<Grid item xs={12} md={6}>
<EnhancedSpecimenRequestGraph data={allDashboardData} />
</Grid>
</Grid> */}

          {/** Orders Table */}
          {/* <Grid item xs={12} md={10}>
<Typography variant="h6" sx={{ backgroundColor: "#c8e6c9", padding: 1, fontWeight:"bold", fontSize:"16px" }}>Order</Typography>
<EnhancedOrdersGraph allOrderData={allOrderData} orderData={orderData} />
</Grid> */}
          <Grid container justifyContent="center" alignItems="center" gap={0}>
            {/* <Grid item xs={12} md={6}>
              <EnhancedOrdersGraph allOrderData={allOrderData} orderData={orderData} />
            </Grid> */}
            <Grid item xs={12} md={6}>
              <OrdersGraph orderData={orderData} allOrderData={allOrderData} />
            </Grid>

            <Grid item xs={12} md={6}>
              {/* <Typography variant="h6" sx={{ backgroundColor: "#c8e6c9", padding: 1, fontWeight:"bold", fontSize:"16px" }}>Series Wise Amount</Typography> */}
              <EnhancedSeriesGraph data={data} />
            </Grid>
          </Grid>


          <Grid container justifyContent="center" alignItems="center">

            {/* Party Data */}
            <Grid item xs={12} md={6}>
              {/* <Typography variant="h6" sx={{ backgroundColor: "#c8e6c9", padding: 1, fontWeight:"bold", fontSize:"16px" }}>Party data</Typography> */}
              <EnhancedPartyDataGraph data={data} />
            </Grid>

            {/** Team Data Table */}
            <Grid item xs={12} md={6}>
              {/* <Typography variant="h6" sx={{ backgroundColor: "#c8e6c9", padding: 1, fontWeight:"bold", fontSize:"16px" }}>team Data</Typography> */}
              <EnhancedTeamDataGraph data={data} roleId={roleId} />
            </Grid>
          </Grid>

          {/** Products Table */}
          <Grid item xs={12} md={12}>
            <Typography variant="h6" sx={{ color: "black", backgroundColor: "#c8e6c9", padding: 1, fontWeight: "600", fontSize: "16px" }}>Products</Typography>
            <EnhancedProductsGraph data={data} />
          </Grid>


        </Grid>
      )}

      {
        staffMovementReportOpen && <StaffMovementReportModal onClose={() => setStaffMovementReportOpen(false)} />
      }
    </>
  );
};
export default Dashboard;